// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const toggleReportsAccordion = () => ({
    type: actions.TOGGLE_TABM_REPORTS_ACCORDION
});



// WEBPACK FOOTER //
// ./src/tabm/shared/action-creators/reports-accordion.js